import { objectsMatch, } from '@iotv/iotv-v3-types';
import ApiGateway from '../aws/api-gateway/ApiGateway';
const debug = process.env.REACT_APP_DEBUG && true;
const isTypeOnlyQuery = (item) => {
    let isTypeOnlyQuery = false;
    if (item) {
        const cast = item;
        const { objectTypeId, adjacencyType, ...others } = cast;
        isTypeOnlyQuery = !!(objectsMatch({}, others) && typeof objectTypeId === 'string' && adjacencyType);
    }
    return isTypeOnlyQuery;
};
export const getLinkableItems = async (params) => {
    const path = '/getLinkableItems';
    debug && console.log('getLinkableItems', 'params', params);
    const res = (await ApiGateway.post(path, params, 'ConsumerApi'));
    return res;
};
